/* エキップ ホーム刷新 v2 : 出現アニメーション・視差（軽量・reduced-motion対応） */
(function () {
  var roots = document.querySelectorAll('.eq');
  if (!roots.length) return;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  roots.forEach(function (r) { r.classList.add('is-js'); });

  var targets = document.querySelectorAll('.eq [data-r]');
  if (reduce || !('IntersectionObserver' in window)) {
    targets.forEach(function (el) { el.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('in'); io.unobserve(e.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 });
    targets.forEach(function (el) { io.observe(el); });
  }

  var vis = document.querySelector('.eq-hero__vis');
  if (vis && !reduce && window.matchMedia('(pointer: fine)').matches) {
    var hero = vis.closest('.eq-hero'), raf = 0;
    hero.addEventListener('pointermove', function (e) {
      var b = hero.getBoundingClientRect();
      var x = ((e.clientX - b.left) / b.width - 0.5) * 2;
      var y = ((e.clientY - b.top) / b.height - 0.5) * 2;
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () {
        vis.style.setProperty('--mx', x.toFixed(3));
        vis.style.setProperty('--my', y.toFixed(3));
      });
    });
    hero.addEventListener('pointerleave', function () {
      vis.style.setProperty('--mx', 0); vis.style.setProperty('--my', 0);
    });
  }
})();
